import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./Register.css";
import { useAppDispatch } from "../store/hooks";
import { registerUser, verifyOTP } from "../store/slices/userSlice";
import { formatPhoneNumber, unformatPhoneNumber } from "../utils/phoneNumber";

export default function Register() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "+90",
    userType: "institution",
    password: "",
    confirmPassword: "",
  });
  const [otpCode, setOtpCode] = useState("");
  const [showOTP, setShowOTP] = useState(false);
  const [error, setError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  const handleChange = (e) => {
    if (e.target.name === "phone") {
      const formatted = formatPhoneNumber(e.target.value);
      setFormData({
        ...formData,
        [e.target.name]: formatted,
      });
    } else {
      setFormData({
        ...formData,
        [e.target.name]: e.target.value,
      });
    }
    setError("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccessMessage("");

    // Şifre kontrolü
    if (formData.password !== formData.confirmPassword) {
      setError("Şifreler eşleşmiyor.");
      return;
    }

    if (formData.password.length < 6) {
      setError("Şifre en az 6 karakter olmalıdır.");
      return;
    }

    try {
      const result = await dispatch(registerUser(formData));

      if (registerUser.fulfilled.match(result)) {
        // OTP gönderildi, OTP ekranını göster
        setShowOTP(true);
        setSuccessMessage(
          result.payload?.message ||
            "OTP gönderildi. Lütfen email'inizi kontrol edin.",
        );
        // Development'ta OTP response'da dönebilir
        if (result.payload?.data?.otp) {
          setOtpCode(result.payload.data.otp);
        }
      } else {
        // Register başarısız
        setError(
          result.error?.message || "Kayıt başarısız. Lütfen tekrar deneyin.",
        );
      }
    } catch (err) {
      setError("Bir hata oluştu. Lütfen tekrar deneyin.");
    }
  };

  const handleOTPSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!otpCode || otpCode.length !== 6) {
      setError("Lütfen 6 haneli OTP kodunu girin.");
      return;
    }

    try {
      const result = await dispatch(
        verifyOTP({
          email: formData.email,
          otp: otpCode,
          purpose: "register",
        }),
      );

      if (verifyOTP.fulfilled.match(result)) {
        // OTP doğrulandı, kayıt tamamlandı, dashboard'a yönlendir
        navigate("/dashboard");
      } else {
        // OTP doğrulama başarısız
        setError(
          result.error?.message ||
            "OTP doğrulama başarısız. Lütfen tekrar deneyin.",
        );
      }
    } catch (err) {
      setError("Bir hata oluştu. Lütfen tekrar deneyin.");
    }
  };

  const handleBackToRegister = () => {
    setShowOTP(false);
    setOtpCode("");
    setError("");
    setSuccessMessage("");
  };

  return (
    <div className="register-container">
      <div className="register-card">
        {!showOTP ? (
          <>
            <div className="register-header">
              <h1>Kayıt Ol</h1>
              <p>Yeni hesap oluşturun</p>
            </div>

            <form onSubmit={handleSubmit} className="register-form">
              {error && (
                <div
                  style={{
                    color: "#e53e3e",
                    backgroundColor: "#fed7d7",
                    padding: "12px",
                    borderRadius: "8px",
                    marginBottom: "16px",
                    fontSize: "14px",
                  }}
                >
                  {error}
                </div>
              )}

              <div className="form-group">
                <label htmlFor="name">Ad Soyad</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Adınız ve soyadınız"
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="email">E-posta</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="ornek@email.com"
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="phone">Telefon</label>
                <input
                  type="text"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  onKeyDown={(e) => {
                    const cursorPosition = e.target.selectionStart;
                    if (
                      cursorPosition <= 3 &&
                      (e.key === "Backspace" || e.key === "Delete")
                    ) {
                      e.preventDefault();
                    }
                  }}
                  placeholder="+90 (XXX) XXX XX XX"
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="password">Şifre</label>
                <input
                  type="password"
                  id="password"
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  placeholder="••••••••"
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="confirmPassword">Şifre Tekrar</label>
                <input
                  type="password"
                  id="confirmPassword"
                  name="confirmPassword"
                  value={formData.confirmPassword}
                  onChange={handleChange}
                  placeholder="••••••••"
                  required
                />
              </div>

              <div className="form-options">
                <label className="terms-checkbox">
                  <input type="checkbox" required />
                  <span>Kullanım şartlarını kabul ediyorum</span>
                </label>
              </div>

              <button type="submit" className="register-button">
                Kayıt Ol
              </button>

              <div className="login-link">
                <p>
                  Zaten hesabınız var mı? <Link to="/login">Giriş yap</Link>
                </p>
              </div>
            </form>
          </>
        ) : (
          <>
            <div className="register-header">
              <h1>OTP Doğrulama</h1>
              <p>Email'inize gönderilen OTP kodunu girin</p>
            </div>

            <form onSubmit={handleOTPSubmit} className="register-form">
              {successMessage && (
                <div
                  style={{
                    color: "#22543d",
                    backgroundColor: "#c6f6d5",
                    padding: "12px",
                    borderRadius: "8px",
                    marginBottom: "16px",
                    fontSize: "14px",
                  }}
                >
                  {successMessage}
                </div>
              )}

              {error && (
                <div
                  style={{
                    color: "#e53e3e",
                    backgroundColor: "#fed7d7",
                    padding: "12px",
                    borderRadius: "8px",
                    marginBottom: "16px",
                    fontSize: "14px",
                  }}
                >
                  {error}
                </div>
              )}

              <div className="form-group">
                <label htmlFor="otp">OTP Kodu</label>
                <input
                  type="text"
                  id="otp"
                  name="otp"
                  value={otpCode}
                  onChange={(e) => {
                    const value = e.target.value.replace(/\D/g, "").slice(0, 6);
                    setOtpCode(value);
                    setError("");
                  }}
                  placeholder="123456"
                  maxLength={6}
                  required
                  style={{
                    textAlign: "center",
                    fontSize: "24px",
                    letterSpacing: "8px",
                    fontFamily: "monospace",
                  }}
                />
                <p
                  style={{
                    fontSize: "12px",
                    color: "#718096",
                    marginTop: "8px",
                    textAlign: "center",
                  }}
                >
                  {formData.email} adresine gönderilen 6 haneli kodu girin
                </p>
              </div>

              <button type="submit" className="register-button">
                Doğrula
              </button>

              <button
                type="button"
                onClick={handleBackToRegister}
                style={{
                  width: "100%",
                  padding: "12px",
                  marginTop: "12px",
                  backgroundColor: "transparent",
                  color: "#4299e1",
                  border: "1px solid #4299e1",
                  borderRadius: "8px",
                  cursor: "pointer",
                  fontSize: "14px",
                }}
              >
                Geri Dön
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
